import React from "react";
import { Button } from "~/components/shared/Button";

import * as styles from "./index.module.scss";

/**
 * Navigation component for quiz questions
 * @param {Object} props - Component props
 * @param {Function} props.onBack - Handler for back button click
 * @param {Function} props.onNext - Handler for next button click
 * @param {boolean} [props.isLastQuestion=false] - Whether this is the last question
 * @param {boolean} [props.disableBack=false] - Whether the back button should be disabled
 * @param {React.ReactNode} [props.children=null] - Child elements to render between buttons
 * @returns {React.ReactElement} QuizNavigation component
 */
export const QuizNavigation = ({
  onBack,
  onNext,
  isLastQuestion = false,
  disableBack = false,
  children = null,
}) => {
  return (
    <div className={styles.navigation}>
      {!disableBack && (
        <Button
          layout="tertiary"
          onClick={onBack}
          data-testid="previous-question"
          withChevron="left"
        >
          Back
        </Button>
      )}
      {children}
      <Button
        className={disableBack && styles.right}
        layout="tertiary"
        onClick={onNext}
        data-testid="next-question"
        withChevron="right"
      >
        {isLastQuestion ? "Results" : "Skip"}
      </Button>
    </div>
  );
};
